// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Khq1g","label":"LabeledBox_label__2M1Ob"};